export default "__VITE_ASSET__CBwpyz4O__"